<template>
  <div>
    <header-applis index-progression-courante="3"/>
    <div class="wrapper__content app-element-center">
      <h2>Vos compétences transversales</h2>
      <p>Afin d’accompagner votre parcours, merci de partager avec nous votre niveau de maitrise sur ces 12 compétences transversales.</p>
      <div class="icon-information">
        <img :src="images.information" alt="">
      </div>
      <p>Il s’agit de questions simples issues du référentiel de l’AEFA (Agenda Européen pour la Formation des Adultes), il vous faudra environ 5 minutes pour y répondre.</p>
      <router-link to="/communiqueroral" tag="button" class="button-app button-primary start-button">OK, commençons les questions</router-link>
      <router-link to="/questionsprofils" class="appcompetences_footer_suivant">Je ne souhaite pas répondre aux questions</router-link>
    </div>
    <footer-applis ecran-precedent="qualificationexperiencediplome"/>
  </div>
</template>

<script>
import FooterApplis from '../components/FooterApplis';
import HeaderApplis from '../components/HeaderApplis';

export default {
  name: 'competencestransversales',
  components: {
    HeaderApplis,
    FooterApplis,
  },
  data() {
    return {
      images: {
        information: require('../assets/images/information.svg'),
      }
    }
  },
}
</script>

<style scoped>
.app-element-center p {
  max-width: 35%;
  text-align: center;
}

.app-element-center .icon-information {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 8em;
  margin: 2rem auto;
  width: 8em;
}

.appcompetences_footer_suivant {
  float: right;
  margin: .5em;
  cursor: pointer;
  padding: .5rem .5rem;
  font-size: 1rem;
}
</style>